import React, { useEffect } from "react";
import AOS from "aos";
import "./Portfolio.css";
import { Link } from "react-router-dom";
import SEO from "../SEO";
export default function Portfolio() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100 });
  }, []);

  const projects = [
    {
      id: 1,
      name: "Point of Sale (POS) System",
      category: "pos",
      icon: "🛒",
      description:
        "Manage sales, inventory, and transactions efficiently in real-time.",
      video: "https://www.youtube.com/embed/MWEID7Io39s",
      title: "POS System Demo 1",
      delay: 0,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 2,
      name: "Advanced POS Platform",
      category: "pos",
      icon: "💳",
      description:
        "Touch-based & manual sales with complete inventory control.",
      video: "https://www.youtube.com/embed/gTiGXKNYYEE",
      title: "POS System Demo 2",
      delay: 100,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 3,
      name: "Enterprise ERP/POS",
      category: "pos",
      icon: "📦",
      description:
        "All-in-one ERP for inventory, accounts, and sales with real-time control.",
      video: "https://www.youtube.com/embed/6unp9xeoQMQ",
      title: "ERP/POS Demo",
      delay: 200,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 4,
      name: "Pharmacy Inventory",
      category: "inventory",
      icon: "💊",
      description:
        "Manage stock, track inventory, and generate real-time reports.",
      video: "https://www.youtube.com/embed/wmhvfZ13V-A",
      title: "Inventory Demo",
      delay: 50,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 5,
      name: "School Management",
      category: "school",
      icon: "🎓",
      description:
        "Manage student records, attendance, grades, and staff-parent communication.",
      video: "https://www.youtube.com/embed/d1XLbfHnE2o",
      title: "School Management Demo",
      delay: 150,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 6,
      name: "E-Commerce Platform",
      category: "inventory",
      icon: "🛍️",
      description:
        "Streamline inventory, orders, and customer data for online stores.",
      video: "https://www.youtube.com/embed/XoD6Vnp8U8c",
      title: "Ecommerce Inventory Demo",
      delay: 250,
      url: "/Portfolio/EnterpriseERP/index",
    },
  ];

  return (
    <>
      <SEO
        title="Portfolio – MZR Software Projects"
        description="Check out MZR Software’s portfolio of custom software, ERP, cloud, and AI development projects."
        image="https://mzrsoftware.com/assets/images/og-portfolio.jpg"
        url="https://mzrsoftware.com/Portfolio/index"
      />

      <section id="portfolio" className="portfolio-section">
        <div className="container">
          {/* Section Header */}
          <div className="section-header text-center mb-5" data-aos="fade-up">
            <h2 className="section-title">
              Our <span className="highlight">Portfolio</span>
            </h2>
            <p className="section-subtitle">
              500+ successful projects delivered across various industries
            </p>
          </div>

          {/* Portfolio Grid */}
          <div className="portfolio-grid">
            {projects.map((project) => (
              <Link key={project.id} to={project.url}>
                <div
                  key={project.id}
                  className="portfolio-card"
                  data-aos="fade-up"
                  data-aos-delay={project.delay}
                >
                  <div className="card-image-wrapper">
                    <iframe
                      width="100%"
                      height="250"
                      src={project.video}
                      frameBorder="0"
                      allowFullScreen
                      title={project.title}
                      className="project-video"
                    ></iframe>
                    <div className="card-overlay">
                      <span className="project-icon">{project.icon}</span>
                    </div>
                  </div>

                  <div className="card-content">
                    <h3 className="card-title">{project.name}</h3>
                    <p className="card-description">{project.description}</p>
                    <div className="card-category">
                      <span className="category-badge">
                        {project.category.toUpperCase()}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Call to Action */}
          <div className="portfolio-cta text-center mt-5" data-aos="fade-up">
            <p className="cta-text">
              Want to see more projects or discuss your requirements?
            </p>
            <Link to="/contact" className="btn-primary">
              Get Started Today →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
